import { render, staticRenderFns } from "./ViewProductComponent.vue?vue&type=template&id=1a058267&"
import script from "./ViewProductComponent.vue?vue&type=script&lang=js&"
export * from "./ViewProductComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports